import { render } from "./SimulationPlayersView.vue?vue&type=template&id=38b4cb97&scoped=true"
import script from "./SimulationPlayersView.vue?vue&type=script&lang=js"
export * from "./SimulationPlayersView.vue?vue&type=script&lang=js"

import "./SimulationPlayersView.vue?vue&type=style&index=0&id=38b4cb97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b4cb97"]])

export default __exports__